import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import HomeLayout from "src/layouts/HomeLayout";
import DashboardLayout from "src/layouts/DashboardLayout";
import LoginLayout from "src/layouts/LoginLayout";

export const routes = [
  {
    exact: true,
    path: "/dashboard",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard")),
  },

  {
    exact: true,
    path: "/users",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard/Userlist")),
  },
  // View user

  {
    exact: true,
    path: "/feedbackMgmt",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Feedback Mgmt/FeedbackHome")
    ),
  },
  {
    exact: true,
    path: "/chatbotMgmt",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Chatbot Mgmt/ChatbotHome")
    ),
  },
  {
    exact: true,
    path: "/edit-users",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard/UserEdit")),
  },
  {
    exact: true,
    path: "/categoryMgmt",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StackingMgmt/StackingTab")
    ),
  },

  {
    exact: true,
    path: "/contentMgmtTable",
    layout: DashboardLayout,
    component: lazy(() => import("src/component/StaticContentTable")),
  },
  {
    exact: true,
    path: "/userDetails",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard/Viewuser")),
  },
  {
    exact: true,
    path: "/changePassword",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Profile/ChangePassword")
    ),
  },
  {
    exact: true,
    path: "/activityView",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Activity Management/AddViewEdit")
    ),
  },
  {
    exact: true,
    path: "/emergencyView",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Emergency Management/AddviewEdit")
    ),
  },
  {
    exact: true,
    path: "/bannerView",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Banner Management/AddViewEdit")
    ),
  },
  {
    exact: true,
    path: "/subActivityView",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Sub Activity management/SubAddViewEdit")
    ),
  },
  {
    exact: true,
    path: "/",
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/LogIn")),
  },
  {
    exact: true,
    path: "/Login",
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/LogIn")),
  },
  {
    exact: true,
    path: "/logo",
    layout: LoginLayout,
    component: lazy(() => import("src/component/Logo")),
  },

  {
    exact: true,
    path: "/forget-password",
    // guard:true,
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/forget-password/index")),
  },
  {
    exact: true,
    path: "/Verify-otp",
    // guard:true,
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/reset-password/VerifyOtp")),
  },
  {
    exact: true,
    path: "/instrauctions",
    // guard:true,
    component: lazy(() => import("src/views/auth/forget-password-link/index")),
  },
  {
    exact: true,
    path: "/reset-password",
    // guard:true,{n}
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/reset-password/index")),
  },
  {
    exact: true,
    path: "/category",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/StakingDetails")),
  },
  {
    exact: true,
    path: "/view-profile",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Profile/ViewProfile")
    ),
  },
  {
    exact: true,
    path: "/edit-profile",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Profile/EditProfile")
    ),
  },
  {
    exact: true,
    path: "/viewReport",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/ReportView")),
  },
  {
    exact: true,
    path: "/report-management",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Press&Media/index")
    ),
  },
  {
    exact: true,
    path: "/add-media",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Press&Media/mediaAdd")
    ),
  },
  {
    exact: true,
    path: "/view-media",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Press&Media/ViewMedia")
    ),
  },
  {
    exact: true,
    path: "/edit-media",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Press&Media/EditMedia")
    ),
  },
  {
    exact: true,
    path: "/resouceMgmt",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/Static")
    ),
  },
  //Add Resource
  {
    exact: true,
    path: "/add-resource",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/AddResource")
    ),
  },
  {
    exact: true,
    path: "/faq-management",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/AddResource")
    ),
  },
  {
    exact: true,
    path: "/Faq-manage/edit",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard/StaticManagement/EditFaqquestion")),
  },
  {
    exact: true,
    path: "/view-resource",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/ViewResource")
    ),
  },
  {
    exact: true,
    path: "/Faq-manage",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/FaqData")
    ),
  },
  {
    exact: true,
    path: "/edit-faq",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/EditFaq")
    ),
  },
  {
    exact: true,
    path: "/add-faq",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/AddFaqquestion")
    ),
  },
  {
    exact: true,
    path: "/emergencyMgmt",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Emergency Management/Index")
    ),
  },
  {
    exact: true,
    path: "/emergencyadd",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Emergency Management/AddEmergency")
    ),
  },
  {
    exact: true,
    path: "/bannerMgmt",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Banner Management/index")
    ),
  },
  {
    exact: true,
    path: "/activityMgmt",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Activity Management/Index")
    ),
  },
  {
    exact: true,
    path: "/activitycategory",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Activity Management/SubActivityTable")
    ),
  },
  {
    exact: true,
    path: "/menstrual-health",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/MensuralHealth")),
  },
  {
    exact: true,
    path: "/mental-health",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/MentalHealthandWellBeing")),
  },
  {
    exact: true,
    path: "/privacy-policy",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/PrivacyPolicy")
    ),
  },
  {
    exact: true,
    path: "/personal-safety",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/PersonalSafety")),
  },
  {
    exact: true,
    path: "/personal-safeties",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/AddViewEdit_personal_safety")
    ),
  },
  {
    exact: true,
    path: "/term-and-condition",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/TermsCondition")
    ),
  },
  {
    exact: true,
    path: "/about-us",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/AboutUs/index")),
  },
  {
    exact: true,
    path: "/personal-safety-view",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>import("src/views/pages/Dashboard/PersonalSafety_View")
    ),
  },

  {
    exact: true,
    path: "/menstrual-health-list",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import(
        "src/views/pages/Dashboard/MenstualHealth/Menstrual_health_List"
      )
    ),
  },

  {
    exact: true,
    path: "/activityorder",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Activity Management/SubActivityorder")
    ),
  },
  {
    exact: true,
    path: "/personal-safety",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Personal_Safety_List")
    ),
  },
  {
    exact: true,
    path: "/sub-activityMgmt",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/Sub Activity management/Index")
    ),
  },
  {
    exact: true,
    path: "/addFAQ",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/AddFAQ")
    ),
  },

  {
    exact: true,
    path: "/view-content",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/About")
    ),
  },
  {
    exact: true,
    path: "/view-contact",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/Contact")
    ),
  },

  {
    exact: true,
    path: "/view-announcements",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/Announcements")
    ),
  },

  {
    exact: true,
    path: "/edit-announcements",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/AnnouncementsEdit")
    ),
  },

  {
    exact: true,
    path: "/edit-content",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/AboutEdit")
    ),
  },

  {
    exact: true,
    path: "/edit-terms",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/TermsConditionEdit")
    ),
  },
  {
    exact: true,
    path: "/feedbackBox",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/feedBackBox")),
  },
  {
    exact: true,
    path: "/chatBotBox",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/component/ChatbotMgmtBox")),
  },
  {
    exact: true,
    path: "/policy",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/PrivacyPolicy")
    ),
  },

  {
    exact: true,
    path: "/edit-policy",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/PrivacyPolicyEdit")
    ),
  },

  {
    exact: true,
    path: "/view-terms",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/StaticManagement/TermsCondition")
    ),
  },

  {
    exact: true,
    path: "/sleep-tracking-list",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/SleepTracking/SleepTracking")
    ),
  },

  {
    exact: true,
    path: "/sleep-tracking",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/SleepTracking/Add_View_Edit")
    ),
  },

  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/errors/NotFound")),
  },
  {
    exact: true,
    path: "/mental-well-being-list",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MentalWellbeing/MentalWellbeing")
    ),
  },
  {
    exact: true,
    path: "/mental-well-being",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MentalWellbeing/ListWellBeing")
    ),
  },
  {
    exact: true,
    path: "/mental-well-being-section",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MentalWellbeing/Add_View_Edit")
    ),
  },
  {
    exact: true,
    path: "/period-tracker",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MenstualHealth/Add_View-Edit")
    ),
  },
  {
    exact: true,
    path: "/menstrual-hygiene-list",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MenstrualHygiene/Menstrual_Hygiene")
    ),
  },
  {
    exact: true,
    path: "/menstrual-hygiene-category",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/component/MensuralHealthCategory")
    ),
  },
  {
    exact: true,
    path: "/exercise-suggestion",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/ExerciseSuggestion/Exercisesuggestion")
    ),
  },
  {
    exact: true,
    path: "/activity-data",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MenstrualHygiene/View_add_Edit")
    ),
  },
  {
    exact: true,
    path: "/menstrual-hygiene-category-add-edit",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/Dashboard/MenstrualHygiene/View_add_Edit_Mensural_Category")
    ),
  },
  {
    component: () => <Redirect to="/404" />,
  },
];
